<template lang="html">
  <div class="onboarding-guide">
    <Guide
      :content="content"
      :contentVideo="contentVideo"
      contentHeading="Website Appearance - Colour Pallete"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'OnboardingColours',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'site',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'onboarding-themes',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'onboarding-fonts',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>You can choose a colour from the pre-defined colour palette in the <strong>Appearance panel</strong>. The colour selected will change the background colour of sections on each page on your website.</p>

        <p>The colour shade will adjust depending on if the theme activated is light or dark.</p>

        <div class="helper-text">
          <p>For example, selecting the colour red on a light theme will show a light shaded red for the section backgrounds on your website. To ensure there is a contrast between the background colour and the text, the text colour is automatically adjusted.
          </p>

          <p>Selecting red on whilst using a dark theme will create a darker-shaded red with a light coloured text.</p>
        </div>
        `
    },

    contentVideo() {
      return 'https://cdn.shopify.com/assets2/home/manage-animation-a9cecf49c4414fd02d9fa00482fd30e436fc373208255d90d92491be650b8d13.mp4'
    }
  }
}
</script>
